(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('TrainerDialogController', TrainerDialogController);

    TrainerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Trainer', 'User', 'SocialMedia'];

    function TrainerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Trainer, User, SocialMedia) {
        var vm = this;

        vm.trainer = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();
        vm.socialmedias = SocialMedia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.trainer.id !== null) {
                Trainer.update(vm.trainer, onSaveSuccess, onSaveError);
            } else {
                Trainer.save(vm.trainer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:trainerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
